import { AsyncCallArgs, BorderGreyBox, CardSpg, useAsyncCall } from "@duosoftbg/nacid-components";
import { CardContent, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import { searchCountryDetails } from "../../../axios/api/services";
import PageWrapper from "../../components/common/layout/PageWrapper";
import EducationSystemsOverviewSearchForm from "../../components/qualCompare/EducationSystemsOverviewSearchFrom";
import { MapOfTheWorld } from "./MapOfTheWorld";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MapIcon from "@mui/icons-material/Map";
import { CountryCardsPage } from "./CountryCardsPage";
import { CountryDetails } from "../../../types/QFDataTypes";
import { SalexorTracking } from "./SalexorTracking";

export const EducationSystemsOverviewPageWithMap = () => {
  const filtersData = useAppSelector((state) => (state as any).SearchData.educationSystems?.filtersData);
  const [allCountriesData, setAllCountriesData] = useState<CountryDetails[]>(null);

  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();

  const [results, setResults] = useState<CountryDetails[]>([]);
  const [activeTab, setActiveTab] = useState("cards");

  const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

  const [geoData, setGeoData] = useState(null);

  useEffect(() => {
    fetch(GEO_URL)
      .then((res) => res.json())
      .then((data) => setGeoData(data));
  }, []);

  const search = (filter: any) => {
    const asyncSearch: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: searchCountryDetails(filter),
      processResponseErrors: true,
      onSuccess: (response: { content: SetStateAction<CountryDetails[]> }) => {
        setResults(response.content);
        allCountriesData === null && setAllCountriesData(response.content);
      },
      onError: () => {
        toast.error(t("m.search.error"));
      },
    };
    asyncCall(asyncSearch);
  };

  useEffect(() => {
    search(filtersData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersData]);

  return (
    <>
      <SalexorTracking />
      <PageWrapper centerTitle title={t("t.qualAssess")}>
        <CardSpg my={4} style={{ overflow: "visible", height: "100%" }}>
          <CardContent style={{ position: "relative", height: "100%" }}>
            <Box>
              <div style={{ overflow: "hidden", width: "100%", height: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    width: "200%",
                    transform: `translateX(${activeTab === "cards" ? "0%" : "-50%"})`,
                    transition: "transform 0.4s ease-in-out",
                  }}
                >
                  <div style={{ width: "50%", padding: 10, background: "#fff", borderRadius: 10 }}>
                    {activeTab === "cards" ? (
                      <>
                        <BorderGreyBox width={"96%"}>
                          <EducationSystemsOverviewSearchForm />
                        </BorderGreyBox>
                        <CountryCardsPage results={results} />
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  {activeTab === "map" ? (
                    <div style={{ width: "50%", padding: 10, background: "#fff", borderRadius: 10 }}>
                      <MapOfTheWorld active={allCountriesData} geoData={geoData} />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
                <IconButton onClick={() => setActiveTab("cards")}>
                  <DashboardIcon sx={{ color: activeTab === "cards" ? "#1D5083" : "#656D78" }} />
                </IconButton>
                <IconButton onClick={() => setActiveTab("map")}>
                  <MapIcon sx={{ color: activeTab === "map" ? "#1D5083" : "#656D78" }} />
                </IconButton>
              </div>
            </Box>
          </CardContent>
        </CardSpg>
      </PageWrapper>
    </>
  );
};
